import classNames from 'classnames';
import React from 'react';
import styles from './TableGrid.module.scss';
export function Head({ children }) {
    return React.createElement("div", { className: styles.tableHead }, children);
}
export function Footer({ children }) {
    return (React.createElement("div", { className: styles.tableFooter, "data-test": "table-footer" }, children));
}
export function Body({ children }) {
    return (React.createElement("div", { className: styles.tableBody, "data-test": "table-body" }, children));
}
export function Row({ head, foot, minHeight, children }) {
    const classes = classNames(styles.row, {
        [styles.headRow]: head,
        [styles.footRow]: foot,
    });
    const style = minHeight ? { minHeight } : undefined;
    return (React.createElement("div", { className: classes, style: style, "data-test": "table-row" }, children));
}
export function Cell({ span, align = 'left', children }) {
    const style = {};
    if (span) {
        style.gridColumn = span === 'full' ? '1 / -1' : `span ${span}`;
    }
    const alignMap = { left: 'flex-start', right: 'flex-end', center: 'center' };
    if (align) {
        style.justifyContent = alignMap[align];
    }
    return (React.createElement("div", { className: styles.cell, style: style, "data-test": "table-cell" }, children));
}
function TableGrid({ columns, noBg, borders, rowBorders = true, columnBorders, children, }) {
    const wrapClasses = classNames(styles.wrapper, {
        [styles.noBg]: noBg,
        [styles.borders]: borders,
        [styles.rowBorders]: rowBorders,
        [styles.columnBorders]: columnBorders,
    });
    const gridColumns = columns.map(([min, w]) => `minmax(${min}, ${w})`).join(' ');
    return (React.createElement("div", { className: wrapClasses },
        React.createElement("div", { className: styles.table, style: { '--grid-columns': gridColumns } }, children)));
}
export default TableGrid;
